import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../assets/lang/en'
import zh from '../assets/lang/zh'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

const messages = {
    en: {
        ...en,
        ...enLocale
    },
    zh: {
        ...zh,
        ...zhLocale
    }
}

const vi18n = new VueI18n({
    locale: localStorage.getItem('tmUserLang') || 'zh',
    silentFallbackWarn: true,
    messages
})

export default vi18n